import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import RenderProduct from "./RenderProduct";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Prices from "components/Prices";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { Controller, useForm, useFormContext } from "react-hook-form"; // Assuming you're using react-hook-form
import DeliveryAddressForm from "./DeliveryAddress";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import Label from "components/Label/Label";
import TimePicker from "components/TimePicker";
import { useMenuSchedule } from "contaxt/MenuScheduleContext";
import Cookies from "js-cookie";
import { useDeliveryAvailability } from "../../hooks/useDeliveryAvailability";
// import { useDeliveryAvailability } from "hooks/useDeliveryAvailability";

interface OrderSummaryProps {
  products: any[];
  reOrderData: any;
  setHistoryOrders: Dispatch<SetStateAction<undefined>>;
  setsubTotal: Dispatch<SetStateAction<number>>;
  searchProduct: string;
  calculatingTotalPrice: (item: any) => number;
  merchantname: string;
  toggleAccordion: () => void;
  isAccordionOpen: boolean;
  selectTime: boolean;
  timeOptions: string[] | null | undefined;
  isAsap: boolean;
  handleTipSelection: (tip: string) => void;
  selectedTip: string;
  handleDeliveryTipSelection: (tip: string) => void;
  selectedDeliveryTip: string;
  customTip: any;
  handleCustomTipChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage: string;
  carterror: string;
  NoteContent: () => React.ReactNode;
  allProductPrice: number;
  taxDisplayList: string[];
  taxDisplayTotal: number[];
  finalTip: (selectedTip: string) => number;
  finalDeliveryTip: (selectedDeliveryTip: string) => number;
  storedOrderFee: number;
  storedOrderFeeLabel: string;
  saveDelivery: (value: any) => void;
  quoteId: string;
  quoteProvider: string;
  deliveryFee: string;
  estimatedTime: number;
  pickUp: number;
  totAmt: number;
  isPaymentProcessing: boolean;
  confirmOrder: boolean;
  isQuotesProcessing: boolean;
  deliveryAddress: any;
  pickUpTime: (dateTime: string) => void;
  setDelivery: (delivery: boolean) => void;
  noQuotes: boolean;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  products,
  reOrderData,
  setHistoryOrders,
  setsubTotal,
  searchProduct,
  calculatingTotalPrice,
  merchantname,
  setDelivery,
  // handlePickupTimeChange,
  // handleAsapChange,
  timeOptions,
  isAsap,
  handleTipSelection,
  selectedTip,
  handleDeliveryTipSelection,
  selectedDeliveryTip,
  customTip,
  handleCustomTipChange,
  errorMessage,
  carterror,
  NoteContent,
  allProductPrice,
  taxDisplayList,
  taxDisplayTotal,
  finalTip,
  finalDeliveryTip,
  saveDelivery,
  storedOrderFee,
  storedOrderFeeLabel,
  totAmt,
  quoteId,
  quoteProvider,
  deliveryFee,
  estimatedTime,
  isPaymentProcessing,
  isQuotesProcessing,
  deliveryAddress,
  pickUpTime,
  noQuotes,
}) => {
  const formatMoney = (value: number | string | null | undefined) => {
    const n = Number(value);
    return Number.isFinite(n) ? n.toFixed(2) : "0.00";
  };

  const [items, setItems] = useState(reOrderData?.orderItems || null);

  // const navigate = useNavigate();
  // const { dispatch }: any = useCartDataProvider();
  const [option, setOption] = useState("pickup");
  const [deliveryOn, setDeliveryOn] = useState(false);
  // const [address, setAddress] = useState("");
  const [data, setdata] = useState("");
  const isDelivery = Cookies.get("isDelivery");
  const [quote_id, setQuoteId] = useState(quoteId || null);
  const [isFormValue, setIsFormValue] = useState(false);
  const [newDeliveryFee, setNewDeliveryFee] = useState(
    Number(deliveryFee) / 100 || "0"
  );
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [pickUpTimes, setPickUpTimes] = useState<string>("");
  // const [checkPickUp,setCheckPickUp]=useState(false)
  // const leadpickup = localStorage.getItem("pickUpTime");
  const [newquote, setNewQuote] = useState(noQuotes || false);

  // const [manuScheludeData, setManuScheludeData] = useState<any[]>([]);
  const { data: menuScheludeData, isLoading: scheduleLoading } = useMenuSchedule();
  const [errorMessages, setErrorMessages] = useState("");
  const [schedulePickup, setSchedulePickup] = useState(false);
  
  // Use real-time delivery availability hook
  const { isDeliveryAvailable, isRestaurantOpen, isDeliveryDisabled } = useDeliveryAvailability({
    menuScheduleData: menuScheludeData,
    updateInterval: 60000 // Update every minute
  });
  
  // Keep the old variables for backward compatibility
  const fromTime = Cookies.get("fromTime") || "00:00";
  const toTime = Cookies.get("toTime") || "23:59";
  const checkTime = isRestaurantOpen ? "true" : "false";

  const optionDelivery = (value: any) => {
    if (value === "delivery") {
      setDelivery(true);
    } else {
      setDelivery(false);
    }
  };
  //  const [showTooltip, setShowTooltip] = useState(false);

  //  const handleConfirmClick = () => {
  //    if (deliveryOn) {
  //      setShowTooltip(true);

  //      setTimeout(() => setShowTooltip(false), 7000); // Hide tooltip after 3 seconds
  //    } else {
  //      // Proceed with the confirm order logic
  //    }
  //  };
  const isDark = Cookies.get("theme");
  useEffect(() => {
    if (isDark === "dark") {
      document.body.classList.add("dark-datepicker");
    } else {
      document.body.classList.remove("dark-datepicker");
    }
  }, [isDark]);

  const orderLeadTime =
    // localStorage.getItem("onlineOrderSettingsLeadTime") || 0;
    Cookies.get("onlineOrderSettingsLeadTime") || 0;

  const handleIncrement = (index: number) => {
    const newItems = [...items];
    newItems[index].quantity += 1;
    setItems(newItems);
    calculateSubtotal(newItems);
  };
  // useEffect(() => {
  //   const getMenuSchedule = async () => {
  //     try {
  //       const response: any = await getMenuScheduleData();
  //       setManuScheludeData(response.data);
  //     } catch (error) {
  //     }
  //   };
  //   getMenuSchedule();
  // }, []);

  const {
    control,
    setValue,
    clearErrors,

    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    setQuoteId(quoteId);
  }, [quoteId]);

  const handleDecrement = (index: number) => {
    const newItems = [...items];
    if (newItems[index].quantity > 1) {
      newItems[index].quantity -= 1;
      setItems(newItems);
      calculateSubtotal(newItems);
    }
  };

  const calculateSubtotal = (items: any[]) => {
    let subtotal = allProductPrice;
    items.forEach((item) => {
      subtotal +=
        item.item.onlinePrice * item.quantity +
        (item.orderItemModifiers?.reduce(
          (acc: any, modifier: any) =>
            acc + modifier.modifierItem.onlinePrice * item.quantity,
          0
        ) || 0);
    });
    return subtotal;
  };
  useEffect(() => {
    setNewDeliveryFee(Number(deliveryFee) / 100);
  }, [deliveryFee]);
  const subtotal = reOrderData ? calculateSubtotal(items) : allProductPrice;
  const totalAmount = reOrderData
    ? (
        totAmt +
        Number(newDeliveryFee) +
        subtotal +
        reOrderData.tax -
        allProductPrice
      ).toFixed(2)
    : (totAmt + Number(newDeliveryFee)).toFixed(2);
  useEffect(() => {
    setHistoryOrders(items);
    setsubTotal(subtotal);
  }, [items, subtotal]);

  const handleOptionChange = async (selectedOption: string) => {
    setOption(selectedOption);
    if (selectedOption === "delivery") {
      setDeliveryOn(true);
      setNewDeliveryFee(deliveryFee);
      setSchedulePickup(true);
      setNewQuote(true);
    } else {
      if (isDark === "system") {
        // Apply system mode
        const prefersDarkMode = window.matchMedia(
          "(prefers-color-scheme: dark)"
        ).matches;
        if (prefersDarkMode) {
          document.body.classList.add("dark");
        } else {
          document.body.classList.add("dark");
        }
      }
      await setNewQuote(false);
      setDeliveryOn(false);
      setSchedulePickup(false);
      setQuoteId(null);
      setNewDeliveryFee("0");
      setDeliveryOn(false);
    }
    optionDelivery(selectedOption);
  };

  const handleSave = (data: any) => {
    setdata(data);
    setNewQuote(false);
    saveDelivery(true);
    setDeliveryOn(false);
  };

  useEffect(() => {
    if (selectedDate !== null) {
      const dateTime = handleDateChange(selectedDate) + " " + selectedTime;
      setPickUpTimes(dateTime);
      const error = validatePickupTime(selectedTime);
      if (option === "pickup") {
        setErrorMessages(error);
      } else if (option === "delivery") {
        setErrorMessages("");
      }
      pickUpTime(`${dateTime}:00`);
    } else {
      const currentDate = new Date();
      const orderLeadTimeMinutes = parseInt(orderLeadTime.toString(), 10); // Convert orderLeadTime to integer

      currentDate.setMinutes(currentDate.getMinutes() + orderLeadTimeMinutes);
      const formattedDate = formatDate(currentDate);
      const currentTime = currentDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      const dateTime = formattedDate + " " + currentTime;
      setPickUpTimes(dateTime);
      const error = validatePickupTime(currentTime);
      if (option === "pickup") {
        setNewQuote(false);
        setDeliveryOn(false);
        setErrorMessages(error);
      } else if (option === "delivery") {
        setNewQuote(true);
        setErrorMessages("");
      }

      pickUpTime(`${dateTime}:00`);
      //  const utcCurrentTime = currentDate.toISOString(); // Convert current date and time to UTC
      //  pickUpTime(utcCurrentTime);
    }
  }, [selectedDate, selectedTime, option]);

  const changeDeliveryAddress = () => {
    setQuoteId(null);
    setIsFormValue(true);
  };

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    return `${year}-${month}-${day}`;
  };
  function convertTo12HourFormat(time24: any) {
    let [hours, minutes] = time24.split(":");
    hours = parseInt(hours, 10);

    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12 for midnight and adjust for 12-hour format

    return `${hours}:${minutes} ${period}`;
  }
  const validatePickupTime = (time: any) => {
    const [selectedHour, selectedMinute] = time.split(":").map(Number);

    const [fromHour, fromMinute] = fromTime.split(":").map(Number);
    const [toHour, toMinute] = toTime.split(":").map(Number);

    const selectedTimeInMinutes = selectedHour * 60 + selectedMinute;

    const fromTimeInMinutes = fromHour * 60 + fromMinute;
    const leadMinutes =
      fromTimeInMinutes + parseInt(orderLeadTime.toString(), 10);
    const resultHours = Math.floor(leadMinutes / 60) % 24; // Use modulo 24 to wrap around if > 24 hours
    const resultMinutes = leadMinutes % 60;

    const formattedTime = `${resultHours
      .toString()
      .padStart(2, "0")}:${resultMinutes.toString().padStart(2, "0")}`;

    const toTimeInMinutes = toHour * 60 + toMinute;

    if (fromTimeInMinutes > toTimeInMinutes) {
      if (
        (selectedTimeInMinutes >= fromTimeInMinutes &&
          selectedTimeInMinutes <= 1440) || // from `fromTime` to midnight
        (selectedTimeInMinutes >= 0 && selectedTimeInMinutes <= toTimeInMinutes) // from midnight to `toTime`
      ) {
        return ""; // No error
      }
    } else if (
      selectedTimeInMinutes >= fromTimeInMinutes &&
      selectedTimeInMinutes <
        fromTimeInMinutes + parseInt(orderLeadTime.toString())
    ) {
      return "Pickup available from " + convertTo12HourFormat(formattedTime);
    } else if (
      selectedTimeInMinutes < fromTimeInMinutes ||
      selectedTimeInMinutes > toTimeInMinutes
    ) {
      return "Pickup unavailable: Please select a time between open hours.";
    }
    // No error
    return "";
  };
  const pad = (num: number) => (num < 10 ? "0" + num : num);
  const convertToLocalTime = (time: string): string => {
    if (!time || !time.includes(":")) return "00:00";

    const [hours, minutes] = time.split(":").map(Number);

    const utcDate = new Date();
    utcDate.setUTCHours(hours, minutes, 0, 0);

    const date = new Date(
      utcDate.toLocaleString("en-US", { timeZone: undefined })
    );

    const hourss = pad(date.getHours());
    const minutess = pad(date.getMinutes());
    return `${hourss}:${minutess}`;
  };

  const handleDateChange = (date: Date | null) => {
    const dayName = date?.toLocaleDateString("en-US", { weekday: "long" });
    const FindDate = menuScheludeData?.find((days) => days.menuDay === dayName);
    const fromTime = FindDate?.fromTime ? (FindDate.fromTime).slice(0, 5) : '';
    const toTime = FindDate?.toTime ? (FindDate.toTime).slice(0, 5) : '';
    Cookies.set("fromTime", fromTime);
    Cookies.set("toTime", toTime);
    setSelectedDate(date);
    if (date) {
      const formattedDate = formatDate(date);
      return formattedDate;
    }
  };
  const confirmDisabled =
    isPaymentProcessing ||
    deliveryOn ||
    newquote ||
    (schedulePickup && errorMessages !== "");
  const confirmLabel = isPaymentProcessing
    ? "Payment Processing..."
    : "Confirm Order";
  const mobileSubmitLabel = isPaymentProcessing
    ? "Processing..."
    : "Confirm Order";

  return (
    <>
    <div className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/90 dark:bg-slate-800/50 p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-slate-900 dark:text-slate-100">
        Order summary
      </h3>
      <p className="mt-1 text-xs sm:text-sm text-slate-500 dark:text-slate-400 lg:hidden">
        Review your items and totals, then enter payment below.
      </p>

      <div className="mt-4 sm:mt-6 lg:mt-8 divide-y divide-slate-200/70 dark:divide-slate-700 ">
        <>
          {carterror && <p className="text-red-500 mt-2">{carterror}</p>}
          {products
            ?.filter((item: any) =>
              item.name.toLowerCase().includes(searchProduct.toLowerCase())
            )
            .map((item: any, index: any) => (
              <RenderProduct
                key={index}
                item={item}
                index={index}
                calculatingTotalPrice={calculatingTotalPrice}
                merchantname={merchantname ?? `${merchantname}`}
              />
            ))}
        </>
        {reOrderData &&
          reOrderData.orderItems
            ?.filter((item: any) =>
              item.item.name.toLowerCase().includes(searchProduct.toLowerCase())
            )
            .map((item: any, index: any) => {
              let totalPrice =
                item.item.onlinePrice * item.quantity +
                (item.orderItemModifiers?.reduce(
                  (acc: any, modifier: any) =>
                    acc + modifier.modifierItem.onlinePrice * item.quantity,
                  0
                ) || 0);
              return (
                <div
                  key={index}
                  className="relative flex py-4 sm:py-5 xl:py-6 first:pt-0 last:pb-0"
                >
                  <div className="ml-2 sm:ml-3 flex flex-1 flex-col">
                    <div>
                      <div className="flex justify-between ">
                        <div className="flex-[1.5] ">
                          <h3 className="text-base font-semibold">
                            {" "}
                            {item.item.name}
                          </h3>
                          <div className="mt-1.5 sm:mt-2.5 flex text-sm text-slate-600 dark:text-slate-300">
                            <div className="flex items-center space-x-1.5"></div>
                            <span className="mx-4 border-l border-slate-200 dark:border-slate-700 "></span>
                            <div className="flex items-center space-x-1.5"></div>
                          </div>

                          <div className="mt-3 flex justify-between w-full sm:hidden relative">
                            <div className="sm text-center relative">
                              {/* <NcInputNumber
                                className="relative z-40"
                                quantity={item.quantity}
                                id={item.item.id}
                                modifierChecked={item.modifierChecked}
                                item={item.item}
                              /> */}
                              <div className="nc-NcInputNumber flex items-center justify-between space-x-5 relative z-20">
                                <div
                                  className={`nc-NcInputNumber__content flex items-center justify-between w-[104px] sm:w-28`}
                                >
                                  <button
                                    className="w-6 h-6 rounded-full flex items-center justify-center border border-neutral-400 dark:border-neutral-500 bg-white dark:bg-neutral-900 focus:outline-none hover:border-neutral-700 dark:hover:border-neutral-400 disabled:hover:border-neutral-400 dark:disabled:hover:border-neutral-500 disabled:opacity-50 disabled:cursor-default"
                                    type="button"
                                    onClick={() => {
                                      handleDecrement(index);
                                      totalPrice -= item.item.onlinePrice;
                                    }}
                                    disabled={item.quantity <= 1}
                                  >
                                    <MinusIcon className="w-4 h-4" />
                                  </button>
                                  <span className="select-none block flex-1 text-center leading-none">
                                    {item.quantity}
                                  </span>
                                  <button
                                    className="w-6 h-6 rounded-full flex items-center justify-center border border-neutral-400 dark:border-neutral-500 bg-white dark:bg-neutral-900 focus:outline-none hover:border-neutral-700 dark:hover:border-neutral-400 disabled:hover:border-neutral-400 dark:disabled:hover:border-neutral-500 disabled:opacity-50 disabled:cursor-default"
                                    type="button"
                                    onClick={() => {
                                      handleIncrement(index);
                                      totalPrice += item.item.onlinePrice;
                                    }}
                                    disabled={false}
                                  >
                                    <PlusIcon className="w-4 h-4" />
                                  </button>
                                </div>
                              </div>
                            </div>
                            <Prices
                              contentClass="py-1 px-2 md:py-1.5 md:px-2.5 text-base font-semibold h-full"
                              onlinePrice={totalPrice}
                            />
                          </div>
                        </div>

                        <div className="hidden sm:block text-center relative">
                          <div className="hidden sm:block text-center relative">
                            <div className="nc-NcInputNumber flex items-center justify-between space-x-5 relative z-20">
                              <div
                                className={`nc-NcInputNumber__content flex items-center justify-between w-[104px] sm:w-28`}
                              >
                                <button
                                  className="w-6 h-6 rounded-full flex items-center justify-center border border-neutral-400 dark:border-neutral-500 bg-white dark:bg-neutral-900 focus:outline-none hover:border-neutral-700 dark:hover:border-neutral-400 disabled:hover:border-neutral-400 dark:disabled:hover:border-neutral-500 disabled:opacity-50 disabled:cursor-default"
                                  type="button"
                                  onClick={() => {
                                    handleDecrement(index);
                                    totalPrice -= item.item.onlinePrice;
                                  }}
                                  disabled={item.quantity <= 1}
                                >
                                  <MinusIcon className="w-4 h-4" />
                                </button>
                                <span className="select-none block flex-1 text-center leading-none">
                                  {item.quantity}
                                </span>
                                <button
                                  className="w-6 h-6 rounded-full flex items-center justify-center border border-neutral-400 dark:border-neutral-500 bg-white dark:bg-neutral-900 focus:outline-none hover:border-neutral-700 dark:hover:border-neutral-400 disabled:hover:border-neutral-400 dark:disabled:hover:border-neutral-500 disabled:opacity-50 disabled:cursor-default"
                                  type="button"
                                  onClick={() => {
                                    handleIncrement(index);
                                    totalPrice += item.item.onlinePrice;
                                  }}
                                  disabled={false}
                                >
                                  <PlusIcon className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="hidden flex-1 sm:flex justify-end text-base font-semibold">
                          <Prices onlinePrice={totalPrice} className="mt-0.5" />
                        </div>
                      </div>
                    </div>

                    {item.orderItemModifiers &&
                      item.orderItemModifiers.length > 0 && (
                        <div className="mt-2">
                          {item.orderItemModifiers.map(
                            (modifier: any, modifierIndex: any) => (
                              <div
                                key={modifierIndex}
                                className="flex flex-col"
                              >
                                <h3 className="text-xs flex justify-between pb-2">
                                  <span>{modifier.modifierItem.name}</span>
                                  <span className="text-slate-900 dark:text-slate-200">
                                    ${formatMoney(modifier.modifierItem.onlinePrice)}
                                  </span>
                                </h3>
                              </div>
                            )
                          )}
                        </div>
                      )}
                  </div>
                </div>
              );
            })}
      </div>

      <div className="mt-6 sm:mt-10">
        <div className="mt-4 text-sm text-slate-500 dark:text-slate-400">
          <div className="flex items-stretch rounded-lg overflow-hidden ring-1 ring-slate-200 dark:ring-slate-600">
            <button
              type="button"
              onClick={() => handleOptionChange("pickup")}
              className={`flex-1 min-h-[38px] sm:min-h-[42px] md:min-h-[44px] px-1.5 py-1.5 sm:px-2 sm:py-2 md:py-2.5 text-xs sm:text-sm md:text-base font-medium rounded-none touch-manipulation ${
                option === "pickup"
                  ? "bg-custom-green  text-white "
                  : "bg-gray-200 text-gray-700 dark:bg-black dark:text-white"
              }`}
            >
              Pickup
            </button>
            <div className="w-px shrink-0 bg-slate-300 dark:bg-slate-600" aria-hidden />
            {isDelivery === "true" && (
              <button
                type="button"
                onClick={() => handleOptionChange("delivery")}
                className={`flex-1 min-h-[38px] sm:min-h-[42px] md:min-h-[44px] px-1.5 py-1.5 sm:px-2 sm:py-2 md:py-2.5 text-xs sm:text-sm md:text-base font-medium rounded-none touch-manipulation ${
                  option === "delivery"
                    ? "bg-custom-green text-white"
                    : isDeliveryDisabled
                    ? "bg-gray-400 text-gray-500 cursor-not-allowed"
                    : "bg-gray-200 text-gray-700 dark:bg-black dark:text-white"
                } `}
                disabled={isDeliveryDisabled}
                title={isDeliveryDisabled ? "Delivery unavailable - Restaurant is closed" : "Delivery available"}
              >
                Delivery{isDeliveryDisabled ? " (closed)" : ""}
              </button>
            )}
          </div>
          {option === "pickup" && (
            <div className="space-y-4">
              {" "}
              <div className="flex items-stretch mt-4 sm:mt-6 rounded-lg overflow-hidden ring-1 ring-slate-200 dark:ring-slate-600">
                <button
                  type="button"
                  onClick={() => setSchedulePickup(false)}
                  disabled={isDeliveryDisabled}
                  className={`flex-1 min-h-[40px] sm:min-h-[44px] md:min-h-[48px] px-1.5 py-1.5 sm:px-2 sm:py-2 text-[10px] sm:text-xs md:text-sm font-medium leading-tight rounded-none touch-manipulation ${
                    !schedulePickup && !isDeliveryDisabled
                      ? "bg-custom-green  text-white"
                      : isDeliveryDisabled
                      ? "bg-gray-400 text-gray-500 cursor-not-allowed"
                      : "bg-gray-200 text-gray-700 dark:bg-black dark:text-white"
                  }`}
                  title={isDeliveryDisabled ? "Pickup unavailable - Restaurant is closed" : "Pickup available now"}
                >
                  <span className="block sm:inline">ASAP </span>
                  <span className="text-[9px] sm:text-[10px] md:text-sm opacity-90 sm:opacity-100">
                    (~{orderLeadTime} min)
                  </span>
                  {isDeliveryDisabled && (
                    <span className="block text-[9px] sm:text-[10px] mt-0.5">Closed</span>
                  )}
                </button>
                <div className="w-px shrink-0 bg-slate-300 dark:bg-slate-600" aria-hidden />
                <button
                  type="button"
                  onClick={() => setSchedulePickup(true)}
                  className={`flex-1 min-h-[40px] sm:min-h-[44px] md:min-h-[48px] px-1.5 py-1.5 sm:px-2 sm:py-2 text-[10px] sm:text-xs md:text-sm font-medium leading-tight rounded-none touch-manipulation ${
                    schedulePickup || isDeliveryDisabled
                      ? "bg-custom-green text-white"
                      : "bg-gray-200 text-gray-700 dark:bg-black dark:text-white"
                  } `}
                >
                  Schedule
                  <span className="hidden sm:inline"> pickup</span>
                </button>
              </div>
              {(schedulePickup || isDeliveryDisabled) && (
                <>
                  <div>
                    <label className="text-sm font-semibold block mb-2 mt-4">
                      <span className="text-red-500">*</span>
                      Select Date:
                    </label>
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => handleDateChange(date)}
                      minDate={new Date()}
                      maxDate={
                        new Date(new Date().setDate(new Date().getDate() + 13))
                      }
                      className="border border-slate-300 dark:border-slate-600 py-2 px-3 rounded-md w-full bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100"
                      placeholderText="Select Date"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-semibold block mb-0">
                      <span className="text-red-500">*</span>
                      Select Time :
                    </label>

                    <TimePicker
                      name="time"
                      value={selectedTime}
                      onChange={(e: any) => setSelectedTime(e.target.value)}
                      className="border border-slate-300 dark:border-slate-600 py-2 px-3 rounded-md w-full bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100"
                    />
                    {errorMessages && (
                      <div className="text-red-500 mt-2">{errorMessages}</div>
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {option === "delivery" && !quote_id && (
            <DeliveryAddressForm
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              namespace="delivery"
              isFormValue={isFormValue}
              // setData={setDeliveryData}
              // quoteId={quoteId}
            />
          )}
          {option === "delivery" && quote_id && (
            <div className="border p-4 rounded-lg shadow-sm mt-4">
          <h1 className="text-xl font-medium text-black dark:text-white">
  Delivery Details
</h1>
              <p>
                <strong>Deliver To (Name):</strong>{" "}
                {deliveryAddress.customer_name || "N/A"}
              </p>
              <p>
                <strong>Contact Number:</strong>{" "}
                {deliveryAddress.customer_phone || "N/A"}
              </p>
              <p>
                <strong>Address 1:</strong>{" "}
                {deliveryAddress.dropoff_street || "N/A"}
              </p>
              <p>
                <strong>Address 2:</strong>{" "}
                {deliveryAddress.dropoff_suite || "N/A"}
              </p>
              <p>
                <strong>City:</strong> {deliveryAddress.dropoff_city || "N/A"}
              </p>
              <p>
                <strong>State:</strong> {deliveryAddress.dropoff_state || "N/A"}
              </p>
              <p>
                <strong>Country:</strong>{" "}
                {deliveryAddress.dropoff_country || "N/A"}
              </p>
              <p>
                <strong>Zipcode:</strong> {deliveryAddress.dropoff_zip || "N/A"}
              </p>
              <p>
                <strong>Delivery Instructions:</strong>{" "}
                {deliveryAddress.dropoff_instructions || "N/A"}
              </p>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  changeDeliveryAddress();
                }}
                className="block text-green-900 hover:text-green-1000 mt-4 text-center underline"
              >
                Change Delivery Address
              </a>
            </div>
          )}
        </div>
      </div>
      {option === "delivery" && quote_id && (
        <div className="border p-4 rounded-lg shadow-sm mt-4 text-gray">
          <p className="text-gray-500">
            <strong>Delivery Provider :</strong> {quoteProvider}
          </p>
          <p className="text-gray-500">
            <strong>ETA :</strong> aprx {estimatedTime} minutes
          </p>
          {/* <h2>Delivery Provider : {quoteProvider}</h2>
          <p>Estimated Time : {estimatedTime} minutes</p> */}
        </div>
      )}
      {option === "delivery" && !quote_id && (
        <>
          {noQuotes && (
            <div className="text-red-600 text-sm mb-2">
              Sorry, Delivery address is out of range. Please enter a different
              address or switch to pickup.
            </div>
          )}
          <ButtonPrimary
            className="justify-center mt-8 w-full"
            type="button"
            disabled={isQuotesProcessing}
            onClick={() => handleSave(data)}
          >
            {isQuotesProcessing ? (
              <span className="inline-flex items-center justify-center gap-2 w-full">
                <span
                  className="h-4 w-24 rounded bg-white/25 animate-pulse"
                  aria-hidden
                />
                <span>Getting delivery options…</span>
              </span>
            ) : (
              "Choose Delivery Option"
            )}
          </ButtonPrimary>
        </>
      )}
      {option === "delivery" && quote_id && (
        <ButtonPrimary
          className="justify-center mt-8 w-full "
          type="button"
          disabled={isQuotesProcessing}
          onClick={() => handleSave(data)}
        >
          {isQuotesProcessing ? (
            <span className="inline-flex items-center justify-center gap-2 w-full">
              <span
                className="h-4 w-24 rounded bg-white/25 animate-pulse"
                aria-hidden
              />
              <span>Updating options…</span>
            </span>
          ) : (
            " Change Delivery Option"
          )}
        </ButtonPrimary>
      )}

      <div className=" pt-6 text-sm text-slate-500 dark:text-slate-400  border-slate-200/70 dark:border-slate-700 ">
        <div className="mt-1 mb-5">
          {option === "pickup" && (
            <div className="mt-1 mb-5">
              <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                Add a Tip
              </p>
              <div className="flex flex-wrap gap-2 mt-2">
                {["none", "10%", "15%", "20%", "custom"].map((tip) => (
                  <button
                    key={tip}
                    type="button"
                    onClick={() => handleTipSelection(tip)}
                    className={`min-h-[40px] px-3 sm:px-4 py-2 text-sm font-medium border rounded-lg touch-manipulation ${
                      selectedTip === tip
                        ? "bg-black text-white dark:bg-gray-200 dark:text-black border-transparent"
                        : "bg-gray-200 text-gray-700 dark:bg-black dark:text-white border-slate-200 dark:border-slate-600"
                    }`}
                  >
                    {tip}
                  </button>
                ))}
              </div>
              {selectedTip === "custom" && (
                <div className="mt-4 w-full max-w-md">
                  <input
                    type="number"
                    value={formatMoney(customTip)}
                    onChange={handleCustomTipChange}
                    placeholder="Tip amount"
                    className="min-h-[44px] text-base w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg dark:bg-slate-800 dark:text-slate-100"
                  />
                  {errorMessage && (
                    <p className="text-red-500 mt-2">{errorMessage}</p>
                  )}
                </div>
              )}
            </div>
          )}
          {option === "delivery" && (
            <div className="mt-1 mb-5">
              <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                Delivery Tip
              </p>
              <div className="flex flex-wrap gap-2 mt-2">
                {["none", "10%", "15%", "20%", "custom"].map((tip) => (
                  <button
                    key={tip}
                    type="button"
                    onClick={() => handleDeliveryTipSelection(tip)}
                    className={`min-h-[40px] px-3 sm:px-4 py-2 text-sm font-medium border rounded-lg touch-manipulation ${
                      selectedDeliveryTip === tip
                        ? "bg-black text-white border-transparent dark:bg-gray-200 dark:text-black"
                        : "bg-gray-200 text-gray-700 dark:bg-black dark:text-white border-slate-200 dark:border-slate-600"
                    }`}
                  >
                    {tip}
                  </button>
                ))}
              </div>
              {selectedDeliveryTip === "custom" && (
                // <div className="mt-4 flex items-center">
                //   <input
                //     type="number"
                //     value={customTip}
                //     onChange={handleCustomTipChange}
                //     placeholder="enter the tip amount"
                //     className=" p-1 border border-slate-300 dark:border-slate-600 rounded w-full"
                //   />
                // </div>
                <div className="mt-4 w-full max-w-md">
                  <input
                    type="number"
                    value={formatMoney(customTip)}
                    onChange={handleCustomTipChange}
                    placeholder="Tip amount"
                    className="min-h-[44px] text-base w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg dark:bg-slate-800 dark:text-slate-100"
                  />
                  {errorMessage && (
                    <p className="text-red-500 mt-2">{errorMessage}</p>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        {NoteContent()}
        <div className="mt-4 flex justify-between py-2.5">
          <span>Subtotal</span>
          <span className="font-semibold text-slate-900 dark:text-slate-200">
            ${formatMoney(subtotal)}
          </span>
        </div>
        <div>
          {taxDisplayList.map((taxDisplay, index) => (
            <div key={index} className="mt-1 flex justify-between py-2.5">
              <span>{taxDisplay}</span>
            <span className="font-semibold text-slate-900 dark:text-slate-200">
              ${formatMoney(taxDisplayTotal[index])}
            </span>
            </div>
          ))}
        </div>
        {option === "pickup" && (
          <div className="mt-1 flex justify-between py-2.5">
            <span>Tip</span>
            {selectedTip ? (
              <span className="font-semibold text-slate-900 dark:text-slate-200">
                ${formatMoney(finalTip(selectedTip))}
              </span>
            ) : (
              <span className="font-semibold text-slate-900 dark:text-slate-200">
                $0.00
              </span>
            )}
          </div>
        )}
        {option === "delivery" && (
          <>
            <div className="mt-1 flex justify-between py-2.5">
              <span>Delivery Tip</span>
              {selectedDeliveryTip ? (
                <span className="font-semibold text-slate-900 dark:text-slate-200">
                  ${formatMoney(finalDeliveryTip(selectedDeliveryTip))}
                </span>
              ) : (
                <span className="font-semibold text-slate-900 dark:text-slate-200">
                  $0.00
                </span>
              )}
            </div>
            <div className="mt-1 flex justify-between py-2.5">
              <span>Delivery Fee</span>
              {deliveryFee ? (
                <span className="font-semibold text-slate-900 dark:text-slate-200">
                  ${formatMoney(Number(deliveryFee) / 100)}
                </span>
              ) : (
                <span className="font-semibold text-slate-900 dark:text-slate-200">
                  $0.00
                </span>
              )}
            </div>
          </>
        )}
        <div className="mt-1 flex justify-between py-2.5">
          <span>{storedOrderFeeLabel}</span>
          <span className="font-semibold text-slate-900 dark:text-slate-200">
            ${formatMoney(storedOrderFee)}
          </span>
        </div>
        <div className="flex justify-between font-semibold text-slate-900 dark:text-slate-200 pt-4">
          <span>Order Total</span>
          <span>${formatMoney(totalAmount)}</span>
        </div>
      </div>

      <div className="relative group hidden lg:block">
        <ButtonPrimary
          type="submit"
          form="checkout-order-form"
          className={`justify-center mt-8 w-full ${
            isPaymentProcessing || deliveryOn || newquote
              ? "disabled-button"
              : ""
          }`}
          disabled={confirmDisabled}
        >
          {confirmLabel}
        </ButtonPrimary>
        {deliveryOn && newquote && (
          <div className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-white dark:bg-slate-800 text-red-600 dark:text-red-400 text-sm px-3 py-1 rounded border border-red-600 dark:border-red-500 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            Please choose the delivery option
          </div>
        )}
      </div>
    </div>

    {/* Mobile: sticky total + primary action above app footer (layout mb-[56px]) */}
    <div
      className="lg:hidden fixed left-0 right-0 z-[45] border-t border-slate-200 dark:border-slate-600 bg-white/98 dark:bg-slate-900/98 backdrop-blur-md shadow-[0_-8px_24px_rgba(15,23,42,0.12)] dark:shadow-[0_-8px_24px_rgba(0,0,0,0.35)]"
      style={{ bottom: "56px" }}
    >
      <div
        className="px-3 pt-2 sm:px-4 sm:pt-3 max-w-lg mx-auto w-full space-y-2 pb-[calc(0.875rem+env(safe-area-inset-bottom,0px))] sm:pb-[calc(1rem+env(safe-area-inset-bottom,0px))]"
      >
        <div className="flex flex-col gap-2 sm:gap-3">
          <div className="flex items-center justify-between gap-2 sm:gap-3">
            <span className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Order total
            </span>
            <span className="text-lg sm:text-xl font-bold text-slate-900 dark:text-slate-100 tabular-nums">
              ${formatMoney(totalAmount)}
            </span>
          </div>
          <ButtonPrimary
            type="submit"
            form="checkout-order-form"
            sizeClass="py-2 px-4 min-h-[40px] sm:py-2.5 sm:px-5 sm:min-h-[42px] md:py-3 md:px-6 md:min-h-[46px]"
            fontSize="text-sm font-semibold sm:text-base"
            className={`mx-auto w-full max-w-[min(16rem,86vw)] sm:max-w-[min(18rem,80vw)] md:max-w-[min(20rem,72vw)] justify-center touch-manipulation ${
              isPaymentProcessing || deliveryOn || newquote
                ? "disabled-button"
                : ""
            }`}
            disabled={confirmDisabled}
          >
            {mobileSubmitLabel}
          </ButtonPrimary>
        </div>
      </div>
      {deliveryOn && newquote && confirmDisabled && !isPaymentProcessing && (
        <p className="text-center text-[11px] leading-tight text-amber-700 dark:text-amber-400 px-4 mt-1 pb-2">
          Choose a delivery option in the summary above to enable checkout.
        </p>
      )}
      {schedulePickup && errorMessages !== "" && confirmDisabled && !isPaymentProcessing && !(deliveryOn && newquote) && (
        <p className="text-center text-[11px] leading-tight text-red-600 dark:text-red-400 px-4 mt-1 pb-2">
          Fix pickup time errors above to continue.
        </p>
      )}
    </div>
    </>
  );
};
export default OrderSummary;
